import { DestroyRef, inject, Injectable, signal } from '@angular/core';
import { take, tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RoadOperatorControllerService } from '@generated/backend-api/api/road-operator-controller.service';
import { RoadOperatorDto } from '@generated/backend-api/model/road-operator-dto';

@Injectable({
  providedIn: 'root',
})
export class RoadOperatorService {
  private readonly roadOperatorControllerService = inject(RoadOperatorControllerService);
  private readonly destroyRef = inject(DestroyRef);
  readonly roadOperators = signal<RoadOperatorDto[]>([]);

  initialize() {
    return this.roadOperatorControllerService
      .getAllRoadOperators()
      .pipe(take(1), takeUntilDestroyed(this.destroyRef))
      .pipe(tap({ next: (roadOperators) => this.roadOperators.set(roadOperators) }));
  }
}
